import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { FeaturesService } from '@shared/services/features/features.service';
import { Store } from '@ngxs/store';
import {
  UniversityState,
  UniversityStateModel
} from '@shared/states/university/university.state';
import { map, switchMap, take, debounceTime } from 'rxjs/operators';
import { SubmissionFormState } from '@shared/states/submission-form/submission-form.state';
import { SubmissionFormStateModel, University } from '@shared/types';

@Injectable({
  providedIn: 'root'
})
export class AuthPublicGuard implements CanActivate {
  auth: boolean;
  university: University;
  portalName: string;
  isAdmin:boolean;
  university$ = this.store.select<UniversityStateModel>(UniversityState);
  submissionForm$ = this.store.select<SubmissionFormStateModel>(SubmissionFormState);
  constructor(
    private featuresService: FeaturesService,
    private store:Store,
    private router: Router
  ) {}
  canActivate(route: ActivatedRouteSnapshot): any {

    this.featuresService.authenticated
      .pipe(
        map(auth => auth),
        take(1),
        switchMap(auth => {
            this.auth = auth;
            return this.university$;
        })
      )
      .subscribe(university$ => {
        const { loading, university } = university$;

        if (loading === false && university) {
          if (!this.auth && university.ssoIntegrated) {
            this.featuresService.setAdmin(false);
            this.featuresService.logIn();
          }
        }
      });

    return this.university$.pipe(
      debounceTime(500),
      switchMap(university$ => {
        const { university } = university$;
        this.university = university;
        return this.featuresService.authenticated;
      }),
      map(auth => {
          this.auth = auth;

        if (document.URL.split('/').length < 5 && !this.university) {
          this.router.navigate(['/home']);
        } else if (
          document.URL.split('/').length < 5 &&
          !this.university.ssoIntegrated
        ) {
          return true;
        }

        return this.auth;
      })
    );
  }
}
